<template>
    <section class="tables">
        <vue-snotify></vue-snotify>
        <div class="row mt-5">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">Focus Action</h4>
                    </div>
                    <div class="card-body">
                        <div class="row mt-5">
                            <div class="col-md-12 d-flex align-items-stretch grid-margin">
                                <div class="row flex-grow">
                                    <div class="col-12">
                                        <div class="">
                                            <div class="">
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <table class="table  text-center">
                                                            <thead class="thead-light">
                                                                <tr>
                                                                    <th scope="col">Focus Name</th>
                                                                    <th scope="col">Action</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="(focus,index) in allFocus" :key="index">
                                                                    <th scope="row">{{focus.FocusName}}</th>
                                                                    <td>
                                                                        <button class="btn btn-light btn-sm mr-2" @click="viewFocus(focus)"><i class="fa fa-eye"></i> View</button>
                                                                        <button class="btn btn-primary btn-sm" @click="editFocus(focus)"><i class="fa fa-cog"></i> Edit</button>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Vue from "vue";
import API from '@/api'
import router from '../../router';

export default {
    name: 'focus_action',
    data() {
        return {
            allFocus :{},
        };
    },

    mounted() {
        this.getAllFoucs()
    },
    methods: {
        viewFocus(focus){
            router.push({name:"view_focus",params:{focus:focus}})
        },
        editFocus(focus)
        {
            router.push({name:"edit_focus",params:{id:focus.FocusID,focus:focus}})
        },
        getAllFoucs(){
            API.getAllFoucs(this.getAllFoucsCB,this.errorCB);
        },
        getAllFoucsCB(res){
            this.allFocus = res.data.data;
            this.$showNotification( res.data, 'success')
        },
        errorCB(err) {
            console.log(err);
            this.$showNotification({ message: "Failed system error" }, 'error')
        },
    }
}
</script>
